import React, { useCallback } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Button from "@mui/material/Button";
import MuiDialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

const StyledDialog = styled(MuiDialog)(() => ({
  "& .MuiDialogContent-root": {
    width: "500px"
  }
}));

const Dialog = ({ title, isOpened, onCancel, buttonProps, children }) => {
  const handleKeyDown = useCallback(
    (e) => {
      if (buttonProps?.disabled) {
        return;
      }

      if (e.key === "Enter") {
        buttonProps.onAction && buttonProps.onAction();
      }
    },
    [buttonProps]
  );

  return (
    <StyledDialog open={isOpened} onClose={onCancel} aria-labelledby="form-dialog-title" onKeyDown={handleKeyDown}>
      <DialogTitle id="form-dialog-title">{title}</DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="primary">
          Cancel
        </Button>
        <Button onClick={buttonProps.onAction} color="primary" disabled={buttonProps?.disabled}>
          {buttonProps.name}
        </Button>
      </DialogActions>
    </StyledDialog>
  );
};

Dialog.propTypes = {
  title: PropTypes.string.isRequired,
  buttonProps: PropTypes.object.isRequired,
  onCancel: PropTypes.func.isRequired,
  isOpened: PropTypes.bool.isRequired
};

export { Dialog };
